/**
 * Enveloppe un payload de PUT avec le timestamp de la dernière version connue de l'entité.
 * Le serveur comparera ce timestamp avec son updatedAt courant.
 * Si différent → 409 UPDATE_CONFLICT.
 */
export const buildVersionedPayload = (entity, values) => {
  if (!entity?.updatedAt) return values;
  return { ...values, __lastKnownUpdatedAt: entity.updatedAt };
};

/**
 * Extrait le payload de conflit depuis une erreur axios 409.
 * Retourne { code, model, current } ou null.
 */
export const conflictFromError = (error) => {
  if (error?.response?.status !== 409) return null;
  const data = error.response?.data;
  if (data?.code !== 'UPDATE_CONFLICT') return null;
  return data;
};

const jsonEq = (a, b) => JSON.stringify(a) === JSON.stringify(b);

/**
 * Extrait uniquement les champs que le client a réellement modifiés par rapport à la base (T0).
 * Utilisé pour le re-PUT silencieux : on n'envoie que ce qui a changé, pour ne pas
 * écraser les modifications d'un autre poste sur les autres champs.
 */
export const extractClientChanges = (localValues, baseEntity) => {
  if (!localValues || !baseEntity) return localValues;
  return Object.fromEntries(
    Object.entries(localValues).filter(([key]) => !jsonEq(localValues[key], baseEntity[key]))
  );
};

/**
 * Détecte un vrai conflit 3-way : le serveur ET le client ont modifié le même champ
 * avec des valeurs différentes.
 */
export const hasGenuineConflict = (localValues, serverEntity, baseEntity) => {
  if (!localValues || !serverEntity) return true;
  return Object.keys(localValues).some((key) => {
    const clientChanged = !jsonEq(localValues[key], baseEntity?.[key]);
    if (!clientChanged) return false;
    const serverChanged = !jsonEq(serverEntity[key], baseEntity?.[key]);
    if (!serverChanged) return false;
    return !jsonEq(localValues[key], serverEntity[key]);
  });
};
